import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function AgitationSection() {
  const consequences = ['Tomas decisiones equivocadas', 'Pierdes tiempo', 'Cometes errores evitables', 'Dependés de rumores', 'Sigues postergando decisiones importantes'];
  return <section className="py-16 md:py-24 px-4 bg-slate-dark text-white relative overflow-hidden" data-id="element-24">
      <div className="absolute inset-0 bg-radial-green opacity-20" data-id="element-25" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-black mb-6 text-brand-light" data-id="element-28">
            El problema no es solamente aparecer en un registro...
          </h2>
          <p className="text-xl md:text-2xl font-bold text-white/90" data-id="element-29">
            El verdadero problema es no entender qué está pasando.
          </p>
        </motion.div>

        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20" data-id="element-30">
          <p className="text-lg font-medium mb-6 text-white/80" data-id="element-31">
            Cuando no tienes información:
          </p>

          <ul className="space-y-4 mb-8" data-id="element-32">
            {consequences.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-3 text-lg" data-id="element-33">
                <AlertTriangle className="w-6 h-6 text-gold shrink-0" data-id="element-34" />
                <span data-id="element-35">{item}</span>
              </motion.li>)}
          </ul>

          <div className="text-center pt-6 border-t border-white/20" data-id="element-36">
            <p className="text-xl font-bold text-brand-light" data-id="element-37">
              Mientras tanto, la incertidumbre continúa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}